import DefaultImage from '../../../../../../../assets/image/newShop/defaultImg.png';
import {getPersianDateTimeV2} from '../../../../../../../utilities/helper/GetPersianDateTime';
import InfoRow from '../../../../../../shopping-basket/ItemCard/InfoRow';

const PendingAdvertisementCard = ({storeAd}: {storeAd: IGetMyStoreAdsData}) => {
  const imageSrc =
    storeAd?.main_image?.image ??
    storeAd?.main_image?.image_128 ??
    storeAd?.sub_brand_main_image?.image ??
    DefaultImage;

  return (
    <div className="relative border-[1px] border-gray-300 shadow-sm shadow-gray-100 rounded-lg  p-3 gap-3 flex flex-col text-md">
      {
        <span className="absolute top-3 left-4 text-xs font-medium text-amber-600">
          در انتظار تایید ثبت{' '}
        </span>
      }
      <div className="flex gap-3">
        <img src={imageSrc} alt="عکس آگهی" className="rounded-lg size-16" />
        <div className="flex flex-col ml-2 space-y-4 w-full">
          <span className="block overflow-hidden mt-2 w-full min-w-0 font-medium whitespace-nowrap text-neutral-900 text-ellipsis line-clamp-1 max-w-48">
            {storeAd?.title}
          </span>
          <InfoRow
            icon="icon-clock-dash-time text-lg"
            valueClassName="text-blue-950 font-normal ext-md"
            label="زمان ثبت آگهی"
            value={
              storeAd?.created_at
                ? getPersianDateTimeV2(storeAd?.created_at) ?? 'مشخص نشده'
                : 'مشخص نشده'
            }
            className="gap-2 w-fit"
          />
        </div>
      </div>
    </div>
  );
};

export default PendingAdvertisementCard;
